export default __webpack_public_path__ + "static/media/video.a6874c47.jpg";